// extracted by extract-css-chunks-webpack-plugin
module.exports = {"signInModalMessage":"signInModalMessage_FECXx","text":"text_uVOzE","title":"title_Lp3Lh","prompt":"prompt_lLzYB","button":"button_VnaU3"};